<template>
    <div class="cotainer table-responsive bg-light p-2">
        <button class="btn-close float-end mt-3 me-3" @click.prevent="closeList"></button>
        <h3 class="mx-auto my-3 ">Clasificación en {{ sendSheetInfo.sheetScale }} para la lámina {{
            sendSheetInfo.sheetPresentation }} - <br> {{
        sendSheetInfo.sheetSpecification }}</h3>
        <table class="table table-hover table-bordered my-1">
            <thead>
                <tr>
                    <th scope="col">Espesor</th>
                    <th scope="col">Esp. Inter. mm</th>
                    <th scope="col">Esp. Comm. mm</th>
                    <th scope="col">Const. Peso</th>
                    <th scope="col">Const. Precio</th>
                    <th scope="col">Precio Corte Cz.</th>
                    <th scope="col">Precio Doblez</th>
                    <th scope="col">Precio Oxicorte</th>
                    <th scope="col">Precio Corte Plasma</th>
                    <th scope="col">Precio Corte Laser</th>
                    <th scope="col">Precio Sold. Elect.</th>
                    <th scope="col">Precio Sold. Mig</th>
                    <th scope="col">Precio Pnzd 1</th>
                    <th scope="col">Precio Pnzd 2</th>
                    <th scope="col">Precio Rolado R.</th>
                    <th scope="col">Precio Rolado C.</th>
                    <th scope="col">Precio Pestañado</th>
                    <th scope="col">Precio Abombado</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="sheet in sheets" :key="sheet.id">
                    <th scope="row">
                    <td>{{ sheet.thickness }}</td>
                    </th>
                    <td>{{ sheet.thicknessInternationalMm }}</td>
                    <td>{{ sheet.thicknessCommercialMm }}</td>
                    <td>{{ sheet.constWeight }}</td>
                    <td>{{ sheet.constPrice }}</td>
                    <td>{{ sheet.priceShearCut }}</td>
                    <td>{{ sheet.priceFold }}</td>
                    <td>{{ sheet.priceFlameCutting }}</td>
                    <td>{{ sheet.pricePlasmaCutting }}</td>
                    <td>{{ sheet.priceLaserCutting }}</td>
                    <td>{{ sheet.priceWeldingElectrode }}</td>
                    <td>{{ sheet.priceWeldingMig }}</td>
                    <td>{{ sheet.pricePunching1 }}</td>
                    <td>{{ sheet.pricePunching2 }}</td>
                    <td>{{ sheet.priceRolled }}</td>
                    <td>{{ sheet.priceRolledConical }}</td>
                    <td>{{ sheet.priceEyelashed }}</td>
                    <td>{{ sheet.priceConvex }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        sendSheetInfo: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            sheets: [],
        };
    },
    watch: {
        sendSheetInfo(newVal) {
            if (newVal !== null) {
                this.getSheetTypes();
            }
        },
    },
    methods: {
        closeList() {
            this.$emit("close-list")
        },
        async getSheetTypes() {
            try {
                if (!this.sendSheetInfo.sheetId) {
                    console.log("Sheet id not defined.");
                    return;
                }
                const res = await axios.get(RUTA_SERVIDOR + "api/sheet/type/list", {
                    params: {
                        sheet_main_id: this.sendSheetInfo.sheetId,
                    },
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                })
                    .then((res) => (this.sheets = res.data))
                    .catch((err) => console.log(`There has been an error ${err}`));
            } catch (err) {
                console.log(`An error has occurred: ${err}`);
            }
        },
    },
    mounted() {
        // console.log(this.sendSheetInfo);
        this.getSheetTypes();
    },
};
</script>
<style scoped>
.btnClose {
    float: right;
}
</style>